"use client"
import { sharePostClicked } from "@/app/(app)/(paragraph)/dashboard/metrics/tracking"
import ShareButtons from "@/app/components/ShareButtons"
import { Copy } from "lucide-react"
import { toast } from "sonner"

export default function ShareButtonRow({
  postId,
  postTitle,
  postUrl,
}: {
  postId: string
  postTitle: string
  postUrl: string
}) {
  return (
    <>
      <ShareButtons
        postId={postId}
        url={postUrl}
        socialMediaShareText={postTitle}
      />
      <div className="block font-mono text-foreground bg-background rounded-md p-4 text-xs sm:text-sm break-all border border-gray-300 truncate">
        <div className="flex items-center gap-2 justify-between">
          <div className="truncate">{postUrl}</div>
          <Copy
            className="h-5 w-5 text-muted-foreground cursor-pointer flex-shrink-0 ml-1"
            onClick={() => {
              navigator.clipboard.writeText(postUrl)
              toast.success("Copied to clipboard")
              sharePostClicked(postId, "Copy")
            }}
          />
        </div>
      </div>
    </>
  )
}
